import { render, staticRenderFns } from "./DisponibilitesCalendarLabels.vue?vue&type=template&id=197bd5fb"
import script from "./DisponibilitesCalendarLabels.vue?vue&type=script&lang=ts"
export * from "./DisponibilitesCalendarLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports